import Highway from '@dogstudio/highway';
import { lightbox } from '../components/lightbox';
import { animateIn } from '../animations/gallery';
import { mq } from '../util/matchMedia';
import { carousel } from '../components/carousel';
import { readGlobalState } from '../util/helpers';

class Gallery extends Highway.Renderer {

  constructor(properties) {
    super(properties);
    this.breakpoint = null;
    this.gallery = null;
    this.media = null;
  }

  onEnter() {
    // Store the current breakpoint
    mq.init();
    this.breakpoint = readGlobalState('mq');
    lightbox.init();
    carousel.init();
  }

  onEnterCompleted() {
    // Trigger the loading animation, build the lightbox
    animateIn.init();
    this.getReferenceElements();
    this.addEventListeners();
  }

  onLeave() {
    // Teardown the lightbox
    this.removeEventListeners();
    lightbox.destroy();
    carousel.pause();
  }

  getReferenceElements() {
    // Mobile or desktop gallery, depending on breakpoint
    this.gallery = document.querySelector(`.js-gallery-${this.breakpoint}`);
    this.media = this.gallery.querySelectorAll('.js-gallery-media');
  }

  addEventListeners() {
    // Clicking on a media element opens the lightbox
    this.media.forEach(item => {
      item.addEventListener('click', this.openLightbox);
    });
  }

  openLightbox(e) {
    lightbox.open(e.target)
  }

  removeEventListeners() {
    this.media.forEach(item => {
      item.removeEventListener('click', this.openLightbox)
    });
  }
}

export default Gallery;
